import * as optimizelyReactSDK from "@optimizely/react-sdk";

export const optimizelyInstance = optimizelyReactSDK.createInstance({
    sdkKey: process.env.REACT_APP_OPTIMIZELY_SDK_KEY,
    logLevel: optimizelyReactSDK.enums.LOG_LEVEL.ERROR
});
